export const runPool = async (items, worker, concurrency = 3) => {
  let i = 0;

  const runners = Array.from(
    { length: Math.min(concurrency, items.length) },
    () =>
      (async () => {
        while (i < items.length) {
          const idx = i++;
          await worker(items[idx], idx);
        }
      })()
  );

  await Promise.all(runners);
};